import CustomInput from "components/CustomInput"

export const DropdownComponent = ({ value, values, onChange }) => {

    const getValueId = () => {
        if (value) {
            return values?.find(v => v.value == value?.value)?.id;
        }
        return "";
    }

    const getValueToSave = (val) => {
        if (val) {
            let selectedValue = values?.find(v => v.id.toString() == val);
            let valObj = { ...selectedValue, id: selectedValue?.id?.toString(), value: selectedValue?.name };
            return valObj;
        }
        return null;
    }
    
    return (
        <CustomInput
            elementType='dropdown'
            value={getValueId()}
            values={values}
            onChange={(val) => onChange(getValueToSave(val), "dropdownValue")}
            showEmpty
        />
    )
}